import useEventListener from "@use-it/event-listener";
import { Tooltip } from "../Tooltip/Tooltip";
import type { ReactNode } from "react";
import { useRef } from "react";
import { useAppDispatch, useAppSelector } from "src/common/state/hooks";
import { setCurrentButtonModalGalleryConfirm } from "src/features/gallery/state/gallerySlice";
import { isModalGalleryOpen } from "src/common/state/slice/modal/modalSlice";
import { useEffect } from "react";
import React from "react";

interface IProps {
  cancelText?: string;
  backText?: string;
  nextText?: string;
  cancelCb?: () => void;
  backCb?: () => void;
  backDisabled?: boolean;
  nextCb?: () => void;
  nextDisabled?: boolean;
  nextDisabledTooltipText?: string;
  customButton?: ReactNode;
  customButtonIndex?: number;
  areTheModalGalleryButtons?: boolean;
}

export default function FooterButtons({
  cancelText = "",
  cancelCb,
  backText = "",
  backCb,
  backDisabled = false,
  nextText = "",
  nextCb,
  nextDisabled = false,
  nextDisabledTooltipText = "",
  customButton = null,
  customButtonIndex = 0,
  areTheModalGalleryButtons = false,
}: IProps) {
  const nextButtonRef = useRef<HTMLButtonElement>(null);
  const dispatch = useAppDispatch();

  const isModalGallery = useAppSelector(isModalGalleryOpen);

  useEffect(() => {
    dispatch(setCurrentButtonModalGalleryConfirm(true));
  }, [dispatch]);

  useEventListener("keydown", (e: KeyboardEvent) => {
    if (e.key === "Enter" && nextButtonRef.current && !nextDisabled) {
      if (isModalGallery && !areTheModalGalleryButtons) {
        return;
      }

      e.preventDefault();

      if (nextCb) {
        nextCb();
      } else {
        nextButtonRef.current.click();
      }
    }
  });

  const buttons: ReactNode[] = [];

  if (cancelText && cancelCb) {
    buttons.push(
      <button
        className="font-medium text-base border-0 mr-3"
        type="button"
        onClick={() => cancelCb()}
      >
        {cancelText}
      </button>,
    );
  }
  if (backText) {
    buttons.push(
      <button
        className="btn-alternative-outline mr-3"
        type="button"
        onClick={() => (backCb ? backCb() : null)}
        disabled={backDisabled}
      >
        {backText}
      </button>,
    );
  }
  if (nextText) {
    buttons.push(
      <Tooltip classNameChildren="right-1" message={nextDisabled ? nextDisabledTooltipText : ""}>
        <button
          ref={nextButtonRef}
          className="btn-primary-fill"
          type="submit"
          onClick={() => (nextCb ? nextCb() : null)}
          disabled={nextDisabled}
        >
          {nextText}
        </button>
      </Tooltip>,
    );
  }

  if (customButton) {
    if (customButtonIndex === 0 || customButtonIndex) {
      buttons.splice(customButtonIndex, 0, customButton);
    } else {
      buttons.push(customButton);
    }
  }

  return (
    <div className="sticky bottom-0 bg-gray-100 w-full py-3 flex items-center justify-end px-5 border-t border-gray-300 h-[4.1875rem]">
      {buttons.map((button, index) => (
        <React.Fragment key={index}>{button}</React.Fragment>
      ))}
    </div>
  );
}
